/* eslint-disable max-lines */
import React, { useContext, useState } from 'react';
import { PropTypes } from 'prop-types';
import { makeStyles, Tooltip } from '@material-ui/core';
import Tick from '../../../assets/images/Icon/tick.svg';
import CircleTick from '../../../assets/images/Icon/circleTick.svg';
import MessagesContext from '../../../contexts/messagesContext';
import { AlertDialog, MainDialog, Options } from '../../UI';
import AddOrEditUser from './AddOrEditUser';
import { useDispatch, useSelector } from 'react-redux';
import usePermissions from '../../../hooks/usePermissions';
import LanguageContext from '../../../contexts/languageContext';
import { deleteUser } from '../../../redux/User/UserAction';
import { useHistory } from 'react-router-dom';
import { deleteWorkspace } from '../../../utils/storage';
const styles = makeStyles({
    item: ({ rtl }) => ({
        background: '#fff',
        padding: '15px 8px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        borderInlineEnd: '1.5px solid rgba(206, 210, 214, 0.8)',
        borderBottom: '1.5px solid rgba(206, 210, 214, 0.8)',
        '&:first-child': {
            position: 'sticky',
            right: rtl ? '0' : 'unset',
            left: !rtl ? '0' : 'unset'
        },
        '&:last-child': {
            borderInlineEnd: 'unset'
        }
    }),
    row: {
        display: 'flex',
        alignItems: 'center'
    },
    permission: {
        display: 'flex',
        justifyContent: 'center !important',
        alignItems: 'center'
    },
    polyclinicTag: {
        background: 'rgba(65, 108, 225, 0.2)',
        padding: '5px 12px',
        borderRadius: '4px',
        fontSize: '12px'
    },
    clinicTag: {
        background: '#e7ecf2',
        padding: '5px 12px',
        borderRadius: '4px',
        fontSize: '12px',
        marginInlineEnd: '5px',
        marginBottom: '5px'
    },
    clinicRow: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    name: {
        color: '#232733',
        fontSize: '13px',
        fontWeight: '500'
    },
    username: {
        color: '#989ea3',
        fontSize: '12px',
        fontWeight: '500',
        display: 'block',
        marginTop: '8px'
    },
    tag: ({ isYou }) => ({
        // width: '40px',
        // height: '10px',
        borderRadius: '18px',
        marginInlineStart: '8px',
        background: isYou ? '#2bd268' : '#faa550',
        color: '#fff',
        padding: '0px 8px',
        fontSize: '11px',
        fontWeight: 'bold'
    }),
    tooltipContainer: {
        listStyleType: 'none',
        '& > li': {
            textAlign: 'start',
            unicodeBidi: 'plaintext',
            marginBottom: '18px'
        }
    },
    permissionWrapper: ({ rtl }) => ({
        display: 'flex',
        justifyContent: rtl ? 'flex-end' : 'flex-start',
        alignItems: 'center'
    }),
    title: {
        color: '#545e66',
        fontSize: '13px',
        fontWeight: '500',
        marginBottom: '20px !important',
        lineHeight: 1.7
    },
    imgWrapper: {
        width: '20px',
        height: '20px',
        marginInlineStart: '8px',
        '& img': {
            width: '100%',
            height: '100%'
        }
    },
    hasPermission: {
        color: '#232733',
        fontSize: '13px',
        fontWeight: '500'
    },
    permissionName: {
        fontSize: '13px',
        fontWeight: '500',
        color: '#989ea3'
    },
    tooltip: {
        background: '#fff',
        boxShadow: '0 4px 10px 0 rgba(84, 94, 102, 0.12)',
        border: 'solid 1px #e8ecf2',
        color: 'black',
        margin: 0,
        width: '200px',
        padding: '12px'
    },
    arrow: {
        color: '#fff',
        fontSize: 15,

        '&:before': {
            border: 'solid 1px #e8ecf2'
        }
    }
});
const UsersTable = ({ item: { username, id, first_name, last_name, namespace_access } }) => {
    const { is_assignee, is_owner, clinics, permissions } = namespace_access;
    const { lang } = useContext(LanguageContext);
    const userInfo = useSelector((state) => state.user.userInfo);
    const isYou = id === userInfo?.id;
    const classes = styles({ isYou, rtl: lang === 'fa' });
    const { messages } = useContext(MessagesContext);
    const [showOption, setShowOption] = useState(false);
    const [dialog, setDialog] = useState(false);
    const [alertDialog, setAlertDialog] = useState(false);
    const { permissions: listOfPermissions } = usePermissions();
    const dispatch = useDispatch();
    const history = useHistory();
    const delegatePermissions = listOfPermissions
        .map((permission) => ({ ...permission, name: `delegate_${permission.name}` }))
        .map((item) =>
            permissions?.[item.name] ? { ...item, hasPerm: true } : { ...item, hasPerm: false }
        );

    const TooltipManageUsers = () => {
        return (
            <ul className={classes.tooltipContainer}>
                <li className={classes.title}>{messages.delegatePerm}.</li>
                {delegatePermissions.map((perm) => (
                    <>
                        <li className={classes.permissionWrapper}>
                            <span
                                className={
                                    perm.hasPerm ? classes.hasPermission : classes.permissionName
                                }
                            >
                                {perm.title}
                            </span>
                            <div className={classes.imgWrapper}>
                                {perm.hasPerm && <img src={Tick} alt="tick" />}
                            </div>
                        </li>
                    </>
                ))}
            </ul>
        );
    };
    const options = [
        { label: messages.editInfo, icon: 'edit', value: 0 },
        { label: messages.deleteUser, icon: 'delete', value: 1, notShow: is_owner }
    ];
    const handleSelectOptions = (option) => {
        const { value } = option;
        if (value === 0) {
            setDialog(true);
        } else if (value === 1) {
            setAlertDialog(true);
        }
    };
    const handleDeleteUser = () => {
        dispatch(deleteUser(id));
        setAlertDialog(false);
        if (isYou) {
            deleteWorkspace();
            history.push('/select-clinic');
        }
    };

    return (
        <>
            <AlertDialog
                open={alertDialog}
                alertText={messages.alerts.deleteUser}
                cancelText={messages.no}
                confirmText={messages.yes}
                handleAction={handleDeleteUser}
                handleClose={() => setAlertDialog(false)}
            />
            <div
                className={classes.item}
                onMouseEnter={() => setShowOption(true)}
                onMouseLeave={() => setShowOption(false)}
                onBlur={() => setShowOption(false)}
            >
                <div>
                    <Options
                        top="2"
                        left={lang === 'fa' ? '2' : undefined}
                        right={lang !== 'fa' ? '2' : undefined}
                        width="24px"
                        options={options.filter((item) => !item.notShow)}
                        showIcon={showOption}
                        isSetting
                        handleSelect={handleSelectOptions}
                    />
                    <div className={classes.row}>
                        <span className={classes.name}>
                            {first_name} {last_name}
                        </span>
                        {isYou ? (
                            <span className={classes.tag}>{messages.you}</span>
                        ) : (
                            is_owner && <span className={classes.tag}>{messages.owner}</span>
                        )}
                    </div>
                    <span className={classes.username}>{username}</span>
                </div>
            </div>
            <div className={classes.item}>
                {is_assignee ? (
                    <span className={classes.polyclinicTag}>{messages.polyclinic}</span>
                ) : (
                    <div className={classes.clinicRow}>
                        {clinics?.map((item, index) => (
                            <span key={index} className={classes.clinicTag}>
                                {item.name}
                            </span>
                        ))}
                    </div>
                )}
            </div>
            <div className={`${classes.item} ${classes.permission}`}>
                {permissions?.write_demographic && <img src={Tick} alt="tick" />}
            </div>
            <div className={`${classes.item} ${classes.permission}`}>
                {permissions?.read_clinical && <img src={Tick} alt="tick" />}
            </div>
            <div className={`${classes.item} ${classes.permission}`}>
                {permissions?.write_clinical && <img src={Tick} alt="tick" />}
            </div>
            <div className={`${classes.item} ${classes.permission}`}>
                {permissions?.aggregate_data && <img src={Tick} alt="tick" />}
            </div>
            <div className={`${classes.item} ${classes.permission}`}>
                {permissions?.manage_form && <img src={Tick} alt="tick" />}
            </div>
            <div className={`${classes.item} ${classes.permission}`}>
                {permissions?.manage_clinic && <img src={Tick} alt="tick" />}
            </div>
            <div className={`${classes.item} ${classes.permission}`}>
                {permissions?.manage_user && (
                    <Tooltip
                        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                        title={<TooltipManageUsers />}
                        arrow
                        placement={lang === 'fa' ? 'right-end' : 'left-end'}
                    >
                        <img src={CircleTick} alt="CircleTick" />
                    </Tooltip>
                )}
            </div>
            <MainDialog open={dialog} goBack={() => setDialog(false)}>
                <AddOrEditUser
                    isEditing
                    userId={id}
                    isYou={isYou}
                    isOwner={is_owner}
                    setDialog={() => setDialog(false)}
                    setAlertDialog={() => setAlertDialog(true)}
                />
            </MainDialog>
        </>
    );
};

UsersTable.propTypes = {
    item: PropTypes.string
};
export default UsersTable;
